import Component from 'vue-class-component';
import { getQueryString } from '@/utils/location';
import Vue from 'vue';
import moduleStore from './store/activity';
import activityMixin from '@/mixins/activity-mixin'

@Component({
  mixins: [activityMixin]
})
@moduleStore.initVuex({
  mutationNames:moduleStore.mutationNames,
  actionNames:moduleStore.actionNames
})
export default class ActivityPage extends Vue  {
  accountList: any = []
  wwToken = ''
  platformMap={'dou_yin':'抖音','kuai_shou':'快手'};
  currentActivity: any = {}
  mounted() {
    this.initData()
  }
  initData() {
    this.wwToken = getQueryString('ww_token') || localStorage.getItem('ww_token')
    if (!this.wwToken) return
    //自测代码
    // this.accountList =[{id:1,avatar:'',nickName:'抖音号1',status:1,platform:'dou_yin',updatedAt: '2022-01-01 12:00:00',totalFans:1234},{id:2,avatar:'',nickName:'抖音号2',status:0,platform:'dou_yin',updatedAt: '2022-01-01 12:00:00',totalFans:1235}];
    this.getDouYinUser()
    this.getCurrentActivity()
  }
  /**
   * 获取抖音账号
   */
  getDouYinUser() {
    this.$http('queryDouYinUser').then((res: any) => {
      if (res.code === 200) {
        this.accountList = res.data
      }
    })
  }
  getCurrentActivity(){
    this.$http('queryCurrentActivity').then((res: any) => {
      if (res.code === 200) {
        this.currentActivity = res.data
      }
    })
  }
  handleBtnTap(type: string) {
    if (type === 'add') {
      this.$router.push(`/accredit?ww_token=${this.wwToken}&type=add`)
    } else if (type === 'manage') {
      this.$router.push(`/activityManager`)
    }
  }
  catMeRank() {
    this.$router.push({
      name: 'leaderboardPage'
    })
  }
  //添加作品链接
  addWork(item) {
    this.$router.push({
      path: '/addWorkPage',
      query: {
        activityId: this.currentActivity.activityId,
        // bindAccountId:item.id,
        accountInfo:JSON.stringify(item)
      },
    })
  }
}